import { useEffect, useState } from 'react';

import { isRubikaUser } from '@/Module/Auth/Helper';

type TGuestVariant = 'شاد' | 'روبیکا';

export const useGuestVariant = (): TGuestVariant => {
  const [guestVariant, setGuestVariant] = useState<TGuestVariant>('شاد');

  useEffect(() => {
    if (isRubikaUser()) {
      setGuestVariant('روبیکا');
    } else {
      setGuestVariant('شاد');
    }
  }, []);

  return guestVariant;
};
